import {
  ADD_VENDOR,
  GET_VENDOR,
  GET_VENDORS,
  UPDATE_VENDOR,
  DELETE_VENDOR,
  GET_ONE_VENDORS
} from '../types';

const initialState = {
  single: null,
  list: [],
  totalCount: 0,
};

const reducer = (state = initialState, action) => {
  const { type, payload, totalCount } = action;

  switch (type) {
    case GET_VENDORS:
      return { ...state, list: payload, totalCount:totalCount };
      
    case GET_VENDOR:
      return { ...state, single: payload || initialState.single};

    case UPDATE_VENDOR:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case ADD_VENDOR:
      return {
        ...state,
        list: [payload, ...state.list],
        totalCount: state.totalCount + 1,
      };

    case DELETE_VENDOR:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
        totalCount: state.totalCount - 1,
      };
      case GET_ONE_VENDORS:
        return { ...state, single: payload || initialState.single };      

    default:
      return state;
  }
};

export default reducer;
